export const storyblokProductSearchFiltersParseBooleanToQueryString = (
  fieldName: string,
  value: boolean,
): string | null => `${fieldName}:${value ? 'true' : 'false'}`
